import React, { FC } from 'react'
import { SensorColumnsDataGrid } from 'src/components/columns/sensor'
import { Sensor, SensorState } from 'src/api'
import { useQueryParamsState } from 'src/hooks/ui'
import { SearchParamsKeys, SensorButtons, ViewTypes, SensorFilters } from 'src/enums'
import { SensorsMapView } from 'src/components/ui'
import { SensorListFilters } from 'src/components/forms/sensor'
import { SensorMapFilters } from 'src/components/forms/sensor/sensorMapFilters'
import { CommonSensorList } from './commonSensorsList'
import { ContractorsDataLoader } from './contractorsDataLoader'
import { SensorContextMenu, SensorMenuItemKey, useSensorContextMenu, createActionsColumn } from './sensorContextMenu'

const columns = ({ handleOpenMenu }: { handleOpenMenu: (e: any, row: any) => void }) => [
  SensorColumnsDataGrid.Id(),
  SensorColumnsDataGrid.Model,
  SensorColumnsDataGrid.IMEI,
  SensorColumnsDataGrid.DevEUI,
  SensorColumnsDataGrid.LastPing,
  SensorColumnsDataGrid.BatteryLevel,
  SensorColumnsDataGrid.Description,
  SensorColumnsDataGrid.LastContractor,
  SensorColumnsDataGrid.StateUpdatedAt,
  SensorColumnsDataGrid.StateAuthor,
  SensorColumnsDataGrid.OrderDate,
  SensorColumnsDataGrid.OrderNumber,
  SensorColumnsDataGrid.OrderPart,
  createActionsColumn(handleOpenMenu)
]

interface Props {
  isLoading: boolean
  count: number
  data: Sensor[]
  states: SensorState[]
  refetchSensorList: () => void
}

export const LostSensorList: FC<Props> = ({ data, isLoading, count, refetchSensorList, states }) => {
  const { currentRow, menuAnchorEl, handleOpenMenu, handleCloseMenu } = useSensorContextMenu()
  const queryParams = useQueryParamsState()
  const viewType = queryParams[SearchParamsKeys.ViewType] || ViewTypes.List

  return viewType === ViewTypes.List ? (
    <>
      <CommonSensorList
        columns={columns({ handleOpenMenu })}
        count={count}
        data={data}
        isLoading={isLoading}
        filters={
          <SensorListFilters
            activeFilters={[
              SensorFilters.LowBattery,
              SensorFilters.WeakSignal,
              SensorFilters.LastPingMoreThanHour,
              SensorFilters.SyncPeriod,
              SensorFilters.ReadingsAge,
              SensorFilters.CurrentSensorConfiguration,
              SensorFilters.BleStatus,
              SensorFilters.OrderNumber,
              SensorFilters.OrderDate
            ]}
          />
        }
        buttons={[SensorButtons.QualityControl]}
        checkboxSelection
        refetchSensorList={refetchSensorList}
      />
      <SensorContextMenu
        menuItems={[SensorMenuItemKey.MakeAvailable]}
        currentRow={currentRow}
        menuAnchorEl={menuAnchorEl}
        onOpenMenu={handleOpenMenu}
        onCloseMenu={handleCloseMenu}
        states={states}
        refetchSensorList={refetchSensorList}
      />
    </>
  ) : (
    <SensorsMapView
      data={data}
      isLoading={isLoading}
      filters={
        <ContractorsDataLoader>
          <SensorMapFilters
            activeFilters={[
              SensorFilters.Contractor,
              SensorFilters.LowBattery,
              SensorFilters.WeakSignal,
              SensorFilters.LastPingMoreThanHour,
              SensorFilters.SyncPeriod,
              SensorFilters.ReadingsAge,
              SensorFilters.LocationType,
              SensorFilters.OrderNumber,
              SensorFilters.OrderDate
            ]}
          />
        </ContractorsDataLoader>
      }
    />
  )
}
